import { render, staticRenderFns } from "./ItemSideMenu.vue?vue&type=template&id=289c14e4"
import script from "./ItemSideMenu.vue?vue&type=script&lang=js"
export * from "./ItemSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports